export default __webpack_public_path__ + "static/congstar-nl-f4809a6a217e3cc4b0ea276c5807ab70.jpg";